import { createFileRoute, notFound } from "@tanstack/react-router";
import { ToolDetailPage, ToolNotFoundPage } from "@/pages/tools/ToolsPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { orgRef } from "@/lib/seo/graph";
import { seoHead, SITE_BASE_URL } from "@/lib/seo/head";

export const Route = createFileRoute("/tools/$slug")({
  // Imported on demand so the tool registry is not in every page's startup code.
  loader: async ({ params }) => {
    const { TOOL_BY_SLUG } = await import("@/content/tools");
    const tool = TOOL_BY_SLUG[params.slug];
    if (!tool || tool.route !== `/tools/${params.slug}`) throw notFound();
    return {
      title: tool.title,
      description: tool.description,
      route: tool.route,
      type: tool.type,
      ageRange: tool.ageRange,
      noindex: !tool.indexable || tool.status !== "public",
    };
  },
  head: ({ loaderData: tool }) => {
    if (!tool) return seoHead({ title: "Tool not found", noindex: true });
    const type = tool.type === "check" ? "WebApplication" : "WebPage";
    return seoHead({
      title: tool.title,
      description: tool.description,
      canonical: tool.route,
      pageType: "WebPage",
      noindex: tool.noindex,
      jsonLd: [
        breadcrumbJsonLd([{ name: "Home", url: "/" }, { name: "Free Parent Tools", url: "/tools" }, { name: tool.title, url: tool.route }]),
        ...(type === "WebApplication" ? [{
          "@type": "WebApplication", "@id": `${SITE_BASE_URL}${tool.route}#application`, name: tool.title,
          description: tool.description, url: `${SITE_BASE_URL}${tool.route}`, applicationCategory: "EducationalApplication",
          operatingSystem: "Any", browserRequirements: "Requires a modern web browser", isAccessibleForFree: true,
          audience: { "@type": "Audience", audienceType: `Parents of children aged ${tool.ageRange}` }, provider: orgRef,
        }] : []),
      ],
    });
  },
  notFoundComponent: ToolNotFoundPage,
  component: ToolRoutePage,
});
function ToolRoutePage() { const { slug } = Route.useParams(); return <ToolDetailPage slug={slug} />; }
